<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<app-header></app-header>
<hr>
<div class="contenedor">
    <router-outlet></router-outlet>
</div>
<hr>
<footer>
    <ul class="lista">
        <li>Proyecto realizado por Rodrigo Cosentino</li>
        <li><a target="_blank" href="mailto:direccion@correo.com&subject=Invitacion%20tomar%20algo"><i class="far fa-envelope-open botonFooter"></i></a><a target="_blank" href="https://api.whatsapp.com/send?phone=541136622633&text=Hola%Rodrigo%!" class="ocultar"><i class="fab fa-whatsapp botonFooter botonWApp"></i></a><a target="_blank" href="https://github.com/cosentinowebdev/smn"><i class="fab fa-github-alt botonFooter"></i></a></li>
        <li class="pequeño">El boton de whatsapp solo se visualiza en formato celular o tablet</li>
    </ul>
</footer>
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->


